import React, { useEffect, useState } from "react";
import { Row, Col, Card, Button} from "react-bootstrap";
import Div from "components/Div";
import PageTitle from "components/PageTitle/index";
import Drawer from 'components/Drawer';

import {PricingMatrixFilters} from '../filters/filters';
import FiltersIcon from '@enerex/unified-ui-react/icons/FilterIcon';
// import {RateClassifications} from './const/index'
//charts
// import MonthlyPriceChart from "./charts/monthlyPriceChart";
// import LastMonthPriceTermChart from "./charts/lastMonthPriceTermChart";
// import YearlyPriceChart from "./charts/yearlyPriceChart";
// import StateMonthlyPriceChart from "./charts/stateMonthlyPriceChart";
import PriceTrendChart from "../../charts/priceTrend/index";
import PriceTrendMinMaxChart from "../..//charts/priceTrend/minMax"
import ForwardCurveChart from "../../charts/forwardCurve/index"
// redux
import { Provider } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';
import store from '../../store';
import {generateTrendPriceData, extractUniqueDatesAndPrices} from "../../const/mockData";
import { fetchChartsData } from '../../store/actions/index';
import { useAuth } from "providers/CustomAuthProvider";

const ChartSection = () => {

  const [priceTrendData, setPriceTrendData] = useState([]);
  const dispatch = useDispatch();
  const { isPremium } = useAuth();
  const shouldBlurCharts = isPremium === false;
  const convertToChartData = (data) => {

  };
  const pricingTrendData = useSelector((state) => state.ranking.chartsData?.priceTrend);
  const pricingTrendMinMaxData = useSelector((state) => state.ranking.chartsData?.priceTrendMinMax);
  const forwardCurveData = useSelector((state) => state.ranking.chartsData?.forwardCurve);
  const forwardCurveMinMaxData = useSelector((state) => state.ranking.chartsData?.forwardCurveMinMax);

  useEffect(() => {
    // const response = generateTrendPriceData();
    // const data = extractUniqueDatesAndPrices(response);
    // setPriceTrendData(data);
  }, []);

  useEffect(() => {
    //   dispatch(fetchChartsData());
      // dispatch(fetchRateClasses());
  }, [dispatch]);

  return (
    <>
      <div style={{ position: "relative" }}>
        <div
          style={{
            filter: shouldBlurCharts ? "blur(5px)" : "none",
            pointerEvents: shouldBlurCharts ? "none" : "auto",
            transition: "filter 0.2s ease",
          }}
        >
        <Row className="">
            <Col sm="12"> 
            <PriceTrendChart 
                categories={pricingTrendData?.categories} 
                series={pricingTrendData?.series} 
                title={"Best Pricing Ranks"}
                isLoading={pricingTrendData?.isLoading}
                expandTitleLegendGap={shouldBlurCharts}
            />
            </Col>
        </Row>
        {/* <Row className="xjustify-content-center">
            <Col sm="12"> 
            <PriceTrendChart 
                categories={pricingTrendMinMaxData?.categories} 
                series={pricingTrendMinMaxData?.series} 
                title={"Worst Pricing Ranks"} 
                isLoading={pricingTrendMinMaxData?.isLoading}
            />
            </Col>
        </Row>
        <Row className="xjustify-content-center">
            <Col sm="12"> 
            <PriceTrendChart 
                categories={forwardCurveData?.categories} 
                series={forwardCurveData?.series} 
                title={"Next Best Pricing Ranks"} 
                isLoading={forwardCurveData?.isLoading}
            />
            </Col>
        </Row>
        <Row className="xjustify-content-center">
            <Col sm="12"> 
            <PriceTrendChart 
                categories={forwardCurveMinMaxData?.categories} 
                series={forwardCurveMinMaxData?.series} 
                title={"Next Worst Pricing Ranks"}
                isLoading={forwardCurveMinMaxData?.isLoading}
            />
            </Col>
        </Row> */}
        </div>
      </div>
    </>
  );
};

export default ChartSection;
